import { Injectable } from '@angular/core';
import { Subject, Observable , BehaviorSubject } from 'rxjs';
import { AppService } from 'src/app/app.service';
import { EntityService } from 'src/app/_core/entity.service';
import { DialogsService } from 'src/app/_services/dialogs.service';
import { GeneralUtilsService } from 'src/app/_services/general.utils.service';
import { OrderItemsUtilsService } from 'src/app/order-items/order-items-util.service';
import { OrderHistoryService } from 'src/app/_services/order.history.service';
import { PaymentsService } from 'src/app/_services/payment.serice';
import { ExpayService } from 'src/app/_services/expay.service';

import * as _ from 'lodash';
import moment from 'moment';
import {flatMap} from "lodash";

@Injectable({
	providedIn: 'root'
})
export class OrderService {
	$storage: any;
	inventory: any;
	catalog: any;
	catalogItemsAsFlatArray: any[];

	constructor(
		public appService: AppService,
		public entityService: EntityService,
		public dialogsService: DialogsService,
		public generalUtils: GeneralUtilsService,
		public orderUtils: OrderItemsUtilsService,
		public orderHistory: OrderHistoryService,
		public paymentService: PaymentsService,
		public expayService: ExpayService,
	) {
		this.initNewStorage();
	}

	initNewStorage() {
		this.$storage = {
			service: 'eatin',
			orderMode: 'eatin',
			folderOptions: {},
			cardOption: {},
			order: {
				offerCounters: []
			},
			contact: {},
			basket: [],
			loyalty: {}
		}
	}

	async signInPrompt(workMode): Promise<any> {
		if (!this.appService.regionArgs.requireLoginforAddItems || this.appService.user) return true;
		const signUpPrompt = await this.dialogsService.SignupPrompt(workMode);
		if (!signUpPrompt) throw ({});
		const loginResponse = await this.dialogsService.login(this.$storage.contact, workMode);
		if (!loginResponse) throw ({});
	}

	async initFromURL(sURL?: string) {
		try {
			let url: URL = new URL(sURL);
			let params = this.appService.getURLParams(url);
			if (!params.site) {
				throw ({ msg: 'missingSite' });
			}
			const siteConfig = await this.entityService.getSiteConfig(params.site);
			let newUrl = url.href.replace(url.origin, location.origin)
			document.location.href = newUrl;
		} catch(e) {
			this.appService.alert({content: this.appService.translate("_APP.invalid-qr-scan") });
			console.error(e);
		}
	}

	async initTabitOrder(siteConfig?, historicOrder?) {
		if (this.restoreOrder()) {
			if (this.$storage.hasMobileWallet) {
				try {
					await this.expayService.initMobileWalletScripts();
				} catch (e) {}
			}
			return true;
		}
		await this.init('tabitOrder', siteConfig);
		let config = this.$storage.config;
		if (!this.generalUtils.canCreateEatinOrder(this.$storage.config)) throw({});
		let table = this.appService.urlParams.table;
		const tpConfig = config.tabitpay;
		if (!tpConfig) throw ({log:'TD.missing_configuration'});

		let timeSlot;
		if (table) {
			timeSlot = _.find(config.timeslots, { _id: config.eatin.workhours });
			if (tpConfig.enableTakeaway) this.$storage.canTakeaway = true;
		} else {
			if (!tpConfig.enableTakeaway) throw({log:'TD.takeaway_not_supported'});
			this.$storage.orderMode = this.$storage.service = 'takeaway';
			if (tpConfig.takeaway_schedule) timeSlot = _.find(config.timeslots, { _id: tpConfig.takeaway_schedule });
		}
		if (!timeSlot) timeSlot = config.workHours;
		if (!this.generalUtils.isTimeslotsActive(timeSlot)) throw ({log:'TD.service_outside_workhours'});

		this.$storage.canCreateTabOrder = this.generalUtils.canCreateTabOrder(this.$storage.config);
		this.$storage.orderId = this.appService.getObjectId();
		this.$storage.orderStartDate = new Date();
		this.$storage.tableNumber = table;
		await Promise.all([
			this.getSiteCatalog(),
			this.getSiteInventory(),
			this.getClubs()
		]).then(res => {
			this.prepareCatalog(res[0], res[1], res[2]);
		});
		if (historicOrder) {
			await this.orderHistory.restoreOrder(this.$storage, historicOrder).then((basketOrders) => {
				basketOrders.forEach(basketOrder => {
					this.addToBasket(basketOrder);
				});
			});
		} else {}
		this.orderHistory.restoreBasket(this.$storage);
		this.cacheOrderNow();
	}

	async initAddItems(siteConfig?) {
		await this.init('addItems', siteConfig);
		await Promise.all([
			this.getSiteCatalog(),
			this.getSiteInventory(),
		]).then(res => {
			this.prepareCatalog(res[0], res[1]);
		});
	}

	async init(workMode, siteConfig?) {
		//try {
		//	await this.signInPrompt(workMode);
		//} catch (err) {
		//	throw ({ type: 'CANCELED'});
		//}

		const params = this.appService.urlParams;
		if (!params.site) {
			throw ({ msg: 'missingSite' });
		}
		if (!siteConfig) {
			siteConfig = await this.entityService.getSiteConfig(params.site);
		}
		if (this.appService.regionArgs.requireLoginforAddItems) {}

		let storage = this.$storage;
		storage.workMode = workMode;
		storage.siteId = params.site;
		storage.orderId = params.oid;

		storage.config = siteConfig.config;
		storage.config = siteConfig.config;
		storage.config.settings.translations = storage.config.translations;

		storage.currencySettings = _.get(siteConfig, 'currencySettings', {});
		if (![1, 10, 100].includes(storage.currencySettings.minimalTipDenomination)) storage.currencySettings.minimalTipDenomination = this.appService.region == 'US' ? 1 : 100;

		storage.currentDiner = [{
			"_id": this.orderUtils.getObjectId(),
			"name": ""
		}];

		storage.folderOptions = _.get(storage.config, 'parameters.order_folder_options', {});
		storage.cardOption = _.get(storage.config, 'parameters.order_card_options', {});
		let rowCardImageWidth = (storage.cardOption.rowCardImageWidth || 200) + 'px';
		storage.rowCardImageStyle = {
			width: rowCardImageWidth,
			'min-width': rowCardImageWidth
		}
		this.orderUtils.setCardDisplayProps(storage.cardOption);
		storage.oparational = _.get(storage.config, 'parameters.operational', {});
		if (!storage.oparational.max_items_count) storage.oparational.max_items_count = 30;
		if (!storage.oparational.max_items_amount) storage.oparational.max_items_amount = 2000;
	}

	async getSiteInventory(checkCount = false) {
		let params = this.appService.urlParams, inventory;
		try {
			inventory = await this.entityService.get(`/online-shopper/inventory`, null, { 'ros-organization': this.$storage.siteId });
		} catch (err) {
			//throw (err);
			return {}
		}
		if (checkCount) return _.keyBy(inventory, 'item');
		return _.keyBy(_.filter(inventory, o => o.quantity === 0), 'item');
	}

	async getClubs() {
		if (!this.$storage.config?.settings?.clubMethod) return [];
		let clubs: any[] = [];
		try {
			clubs = await this.entityService.get(`/online-shopper/clubs/?loyaltyProvider=5cff99288dc6d4e785abc0bf`, null, { 'ros-organization': this.$storage.siteId });
		} catch (err) {
			return [];
		}
		return _.filter(clubs, club => {
			if (club.accountGuid != null) {
				if (_.get(club, 'providerData.disabledPlatforms', []).includes("TabitOrder")) return false;
				let disableReg = _.get(club, 'providerData.systemBlockedForNewCustomers');
				if (disableReg && (disableReg as [string]).includes("1DB24FCC-FA2A-42F3-B53F-68D44B23DEC0")) {
					club.disableRegistration = true;
				}
				return true;
			}
			return false;
		});
	}

	async getSiteCatalog() {
		this.getUserHistory();
		let catalog;
		try {
			catalog = await this.entityService.get(`/online-shopper/tdcatalogs/${this.$storage.siteId}`, null, { 'ros-organization': this.$storage.siteId }).then(res => {
				if (!res.itemAttributes) res.itemAttributes = [];
				res.userOffers = [];

				//todo: tabot initiation start
				if (this.$storage.siteId === '67ff97f1b5616567204d0dfb' && this.appService.appConfig.waiterChatbotAPI) res.enableTabot = true;

				return res;
			});
		} catch (err) {
			throw (err);
		}
		return catalog;
	}

	tempHistory;
	async getUserHistory() {
		this.tempHistory = null;
		if (!this.appService.user) return;
		try {
			let history: any = await this.entityService.get(`${this.appService.appConfig.tabitBridge}/customers/full-history/${this.$storage.siteId}`, null, { 'Mobile': this.appService.user.phone });
			if (history && history.length) {
				this.tempHistory = history;
				if (this.$storage.catalog) this.prepareUserHistory('getUserHistory');

			}
		} catch (ex) { }
	}

	prepareCatalog(catalog, inventory = {}, clubs = []) {

		let storage = this.$storage;
		storage.catalog = catalog;

		storage.catalog.inventory = inventory;
		storage.loyaltyClubs = clubs;
		storage.loyaltyClub = clubs[0];

		const config = this.$storage.config;

		const catalogTrans = storage.catalogTrans = this.appService.locale != this.appService.regionArgs.locale && this.appService.locale;
		if (catalogTrans) this.translateCatalog(catalog, config, catalogTrans)

		storage.activeTimeslots = this.generalUtils.calculateTimeSlots(config.timeslots);
		storage.catalog.hideInventory = config.settings.outOfStockDisplay == 'hide';

		//messages ------------------------------------->

		let menuMessages = [];
		storage.messages = _.filter(config.messages, (message) => {
			if (!message.active) return;
			//if (message.scope && message.scope != 'general' && message.scope != storage.service) return;
			if (message.scope != 'eatin') return;
			if (message.schedule && message.schedule != "" && !storage.activeTimeslots[message.schedule]) return;
			if (message.placement === "inMenu") {
				message.trans = _.get(message, `translations.${catalogTrans}.message`, message.message);
				menuMessages.push(message);
			}

			message.isNew = true;
			return true;
		});
		if (menuMessages.length) storage.menuMessages = menuMessages;

		// promotions ----------------------------------->

		if (storage.workMode != 'addItems') storage.order.promotion = this.getSiteActivePromotion();

		// prepare offer bundles ------------------------>

		storage.catalog.offerBundles = _.filter(storage.catalog.offerBundles, bundle => {
			if (bundle.services && bundle.services[0] && !bundle.services.includes(storage.service)) return false;
			if (bundle.schedule && !storage.activeTimeslots[bundle.schedule] && config.timeslots.find(o => o._id == bundle.schedule)) return false;
			return true;
		});

		// weight system ----------------------------------->

		let weightSystem = storage.catalog.weightSystem;
		if (weightSystem) {
			let weightMatrix = [
				{ base: "kg", use: "kg", ratio: 1, increment: 0.5, default: 0.5, decimals: 1, min: 0.5, round: 0.1 },
				{ base: "kg", use: "gr", ratio: 1000, increment: 100, default: 100, decimals: 0, min: 100, round: 50, checkMin: true },
				{ base: "gr", use: "kg", ratio: 0.001, increment: 0.05, default: 0.05, decimals: 2, min: 0.05, round: 0.05 },
				{ base: "lb", use: "lb", ratio: 1, increment: 0.5, default: 0.5, decimals: 1, min: 0.5, round: 0.1 },
				{ base: "lb", use: "oz", ratio: 16, increment: 1, default: 1, decimals: 0, min: 1, round: 0.1 },
				{ base: "oz", use: "lb", ratio: 0.0625, increment: 0.0625, default: 0.0625, decimals: 3, min: 0.0625, round: 0.0625 },
				{ base: "l", use: "ml", ratio: 1000, increment: 100, default: 100, decimals: 0, min: 50, round: 50 },
				{ base: "ml", use: "l", ratio: 0.001, increment: 0.1, default: 0.1, decimals: 2, min: 0.05, round: 0.05 },
			];
			let weightParams: any = storage.catalog.weightParams = _.find(weightMatrix, { base: weightSystem.basicUom, use: weightSystem.defaultUom });
			if (!weightParams) {
				console.error("Missing Weight Parameters");
			} else {
				weightParams.baseTxt = this.appService.translate(`_WEIGHT.${weightParams.base}`);
				weightParams.useTxt = this.appService.translate(`_WEIGHT.${weightParams.use}`);
			}
		}

		// prepare payments    ---------------------------------->

		this.paymentService.prepareConfigPayments(storage, config.paymentAccounts, 'tabitOrder', { timeslots: config.timeslots });

		// prepare tip options ---------------------------------->

		delete storage.tipOptions;
		if (_.get(config, `${storage.orderMode}.enableGratuity`) && storage.hasGratuityPMs) {
			let tipOptions = config[storage.orderMode].tipOptions;
			if (tipOptions) {
				storage.tipOptions = _.assignIn({}, tipOptions, { amount: 0 });
				if (storage.tipOptions.defaultValue) {
					storage.tipOptions.selected = {
						type: storage.tipOptions.valueType,
						value: storage.tipOptions.defaultValue,
					}
				}
			}
		}

		// prepare views --------------------------------->

		storage.isTabsDisplay = false;
		storage.isSubCatTabs = false;

		storage.catalog.folders = [];
		storage.catalog.tmpViewOffers = {};
		storage.catalog.view = _.filter(storage.catalog.view, view => {
			if (this.orderUtils.prepareItemsFolder(storage.catalog, view, storage)) {
				return true;
			}
			return false;
		});

		if (!storage.catalog.view.length) throw ({ code: 105, message: '_LOAD_ERRORS.no_menu' });

		if (storage.catalog.folders.length) {
			storage.catalog.folders = _.orderBy(storage.catalog.folders, ["_id"]);
			let n = storage.catalog.view.length;
			_.each(storage.catalog.folders, (folder, index) => {
				if (storage.isTabsDisplay) {
					folder.tabIndex = n;
					++n;
				} else {
					folder.tabIndex = index + 1;
				}
			});
		}
		this.catalogItemsAsFlatArray = null;
		this.calculateBasketTotal();
		if (this.tempHistory) this.prepareUserHistory('from catalog');
	}

	translateCatalog(catalog, config, local) {
		let arr = ["offers", "items", "itemGroups", "modifierGroups", "view"];
		_.each(arr, attList => {
			_.each(catalog[attList], member => {
				delete member.description;
				if (member.translations) {
					let trans = member.translations[local];
					if (trans) {
						_.each(trans, (val, key) => {
							if (!val || val === "") {
								console.log("erroneus translation", member);
							} else {
								if (key == 'name') {
									member.$$translated = true;
									member.realName = member[key];
								}
								member[key] = val;
							}
						});

					}
				}
				if (member.modifiers) {
					_.each(member.modifiers, modifier => {
						let trans = modifier.translations && modifier.translations[local];
						if (trans) {
							_.each(trans, (val, key) => {
								if (!val || val === "") {
									console.log("erroneus translation", modifier);
								} else {
									if (key == 'name') {
										modifier.realName = modifier[key];
									}
									modifier[key] = val;
								}
							});
						}
					});
				}
			})
		});

		//bundles translation -------------------------------------->

		_.each(catalog.offerBundles, bundle => {
			delete bundle.description;
			if (bundle.translations) {
				let trans = bundle.translations[local];
				if (trans) {
					_.each(trans, (val, key) => {
						bundle[key] = val;
					});
				}
			}
		});
	}

	getCatalogItemsAsFlatArray(reset: boolean = false) {
		if(!this.catalogItemsAsFlatArray || reset) {
			this.catalogItemsAsFlatArray = getAllIMembers(this.$storage.catalog.view);
		}
		return this.catalogItemsAsFlatArray;

		function getAllIMembers(data: any[]): any[] {
			let items =  flatMap(data, item => {
				if (item.type === 'item') {
					return [item];
				} else if (item.items) {
					return getAllIMembers(item.items);
				}
				return [];
			});
			return items;
		}
	}


	getSiteActivePromotion() {
		let storage = this.$storage;
		let config = storage.config;
		let promotion;
		if (config.promotions) {
			for (let i = 0; i < config.promotions.length; i++) {
				var pr = config.promotions[i];
				var sr = pr.services || [];
				if (pr.disabled || pr.valueType === "amount") continue;
				if (pr.orderTime && pr.orderTime != 'sameDay') continue;
				if (pr.type != 'totalTicket') continue;
				if (pr.schedule && !storage.activeTimeslots[pr.schedule]) continue;
				if (sr.length && sr.indexOf(storage.orderMode) == -1) continue;
				promotion = pr;
				break;
			}
		}
		if (promotion) {
			promotion = _.cloneDeep(promotion);
			let catalogTrans = this.appService.locale;
			if (promotion.translations) {
				_.each(promotion.translations[catalogTrans], (val, key) => {
					if (val) promotion[key] = val;
				})
			}
		}
		return promotion;
	};

	// ------------------------------------------------------------------------------------------------->
	// basket utilities
	// ------------------------------------------------------------------------------------------------->

	updateBasket(offer) {
		var index = _.findIndex(this.$storage.basket, { _bid: offer._bid });
		if (index > -1) {
			this.$storage.basket[index] = offer;
		} else {
			this.addToBasket(offer, true);
		}
		this.calculateBasketTotal();
	};

	addToBasket(offer, isUpdate?) {
		let storage = this.$storage;
		offer._bid = this.appService.getObjectId();
		offer.diner = storage.currentDiner._id;
		var _q = offer.quantity;
		if (!_q) offer.quantity = _q = 1;
		if (!offer._enableEdit) {
			var _offer: any = _.find(storage.basket, { offer: offer.offer, diner: storage.currentDiner._id });
			if (_offer) {
				_offer.quantity += _q;
				if (!_offer.upsaleType && offer.upsaleType) _offer.upsaleType = offer.upsaleType;
			}
			else storage.basket.push(offer);
		} else {
			storage.basket.push(offer);
		};
		this.calculateBasketTotal();
		if (!isUpdate) this.animateAddToBasket(offer);
		//this.loyaltyService.onAddToBasket(this.$storage);
		this.cacheOrder();
	};

	addLoyaltyToBasket(offers) {
		let storage = this.$storage, that = this;
		if (offers) {
			if (_.find(storage.basket, { isLoyaltyOffer: true, offer: offers[0].offer })) return;
			do {
				let index = _.findIndex(storage.basket, { isLoyaltyOffer: true });
				if (index == -1) break;
				storage.basket.splice(index, 1);
			} while (true);

			_.each(offers, offer => {
				that.addToBasket(offer);
			});

			this.calculateBasketTotal();
			//this.loyaltyService.getBenefits(storage, true);
		}
	}

	_addingItem: boolean = false;
	animateAddToBasket(_offer) {
		this._addingItem = true;
		window.setTimeout(() => {
			this._addingItem = false;
		}, 500);
	}

	calculateBasketTotal(clean?) {
		var order = this.$storage.order;
		var total = 0;
		var realTotal = 0;
		let loyaltyOffersTotal = 0;
		var q = 0;
		let hasSummaryExtras = false;
		let counters = {};

		_.each(this.$storage.basket, function (offer) {

			if (!offer.quantity) offer.quantity = 1;
			q += offer.quantity;
			if (offer.isLoyaltyOffer) {
				loyaltyOffersTotal += (offer.total * offer.quantity);
			}
			if (offer.promotion && offer.promotion.calc) {
				total += (offer.promotion.calc.newTotal * offer.quantity);
			} else {
				total += (offer.total * offer.quantity);
			};
			realTotal += (offer.total * offer.quantity);
			if (!counters[offer.offer]) {
				counters[offer.offer] = offer.quantity;
			} else {
				counters[offer.offer] += offer.quantity;
			}
		});
		total = _.round(total, 2), realTotal = _.round(realTotal, 2);
		order.offerCounters = counters;
		order.total = total;
		order.realTotal = realTotal;

		if (order.promotion) {
			let loyaltyBenefits = 0; //this.loyaltyService.calculateBenefits()
			let calc = this.calculatePromotion(Math.max(total - loyaltyOffersTotal - loyaltyBenefits, 0), order.promotion);
			if (calc) total = calc.newTotal;
			order.promotion.calc = calc;
			hasSummaryExtras = true;
		}
		var dp = 0;

		let taxAndFees = 0;
		order.loyaltyTotal = 0;
		if (this.$storage.wasTaxesAndFees) {
			if (order.taxAndFees) {
				hasSummaryExtras = true;
				if (!clean) {
					taxAndFees += order.taxAndFees.tax;
					taxAndFees += order.taxAndFees.fees;
				}
			}
			const loyaltyData = this.$storage.loyalty?.loyaltyData;
			if (loyaltyData) {
				order.loyaltyTotal = _.get(loyaltyData, 'pointsUsed', 0) + _.get(loyaltyData, 'totalBenefits', 0);
				if (order.loyaltyTotal) hasSummaryExtras = true;
				dp -= order.loyaltyTotal;
			}
		}

		order.quantity = q;
		let grandTotalBeforeTax = total + dp;
		order.grandTotalBeforeTax = _.round(grandTotalBeforeTax, 2);
		order.grandTotalAfterTax = total + taxAndFees + dp;

		let tip = 0, gratuity = this.$storage.gratuity;
		if (gratuity?.amount) {
			hasSummaryExtras = true;
			tip = gratuity.amount;
		}
		order.tip = tip;

		order.grandTotalForOrder = _.round(total + taxAndFees + dp, 2);

		let grandTotal = total + taxAndFees + tip + dp;
		order.grandTotal = _.round(grandTotal, 2);

		let giftCardsTotal = 0;
		let cards = this.$storage.giftCards?.cards;
		if (cards) giftCardsTotal = _.sumBy(cards,  'amount');
		order.giftCardsTotal = giftCardsTotal;

		this.$storage.hasSummaryExtras = hasSummaryExtras;
	}

	calculateGratuityFromPercent(pVal, totalAmount?) {
		var total = totalAmount || this.$storage.order.grandTotalAfterTax;
		var unroundedGratuity = total * (pVal / 100);
		//unroundedGratuity = Math.max(unroundedGratuity, 1);
		return this.roundGratuity(unroundedGratuity);
	}
	roundGratuity(unroundedGratuity) {
		var minDenom = this.$storage.currencySettings.minimalTipDenomination;
		minDenom = minDenom / 100;
		var roundedGratuity = _.round(unroundedGratuity / minDenom) / (1 / minDenom);
		return _.round(roundedGratuity, 2);
	}

	clearOrderGratuity() {
		delete this.$storage.gratuity;
		this.calculateBasketTotal();
	}

	calculatePromotion(total, promotion) {
		var valid, newTotal, amount, percent;
		valid = newTotal = amount = percent = null;
		if (promotion.type == 'OTH') {
			return {
				newTotal: 0,
				amount: total,
				percent: 100
			}
		} else {
			var vt = promotion.valueType;
			var v = promotion.value;
			let decimals = ['US', 'AU'].includes(this.appService.region) ? 2 : 0;
			if (vt && v) {
				if (vt == 'percent') {
					percent = v;
					amount = _.round((v / 100 * total), decimals);
					newTotal = total - amount;
				} else {
					amount = v;
					newTotal = Math.max(total - amount, 0);
					percent = _.round((total - newTotal) / total * 100, 2);
				}
				return {
					newTotal: newTotal,
					amount: amount,
					percent: percent
				}
			}
		}
	}

	// ------------------------------------------------------------------------------------------------->
	// order utilities
	// ------------------------------------------------------------------------------------------------->

	changeOrderToPickup() {
		try {
			let config = this.$storage.config;
			let timeSlot = config.workHours;
			if (config.tabitpay?.takeaway_schedule) timeSlot = _.find(config.timeslots, {_id: config.tabitpay?.takeaway_schedule});
			if (!this.generalUtils.isTimeslotsActive(timeSlot)) throw ({content: 'TO.change_to_takeaway_unavailable'});
			this.appService.confirm({content:'TO.q_change_to_takeaway'}).then(() => {
				this.$storage.canTakeaway = false;
				this.$storage.orderMode = this.$storage.service = 'takeaway';
				delete this.$storage.tableNumber;
			});
		} catch (e) {
			let message = e.content || 'TO.change_to_takeaway_unavailable';
			this.appService.alert({content: message});
		}
	}

	getMaxRemainingItems() {
		let maxCount = this.$storage.oparational.max_items_count;
		return maxCount - this.$storage.order.quantity;
	}

	validateOrderLimit(op = 0, opAmount?) {
		if (!opAmount) opAmount = op;
		return new Promise((resolve, reject) => {
			let message = null;
			let maxCount = this.$storage.oparational.max_items_count;
			let maxAmount = this.$storage.oparational.max_items_amount;

			if (this.$storage.order.quantity + op > maxCount) message = this.appService.translate('GROUP_VALIDATION.MAX_ITEMS_COUNT', { max: maxCount });
			else if (this.$storage.order.grandTotal + opAmount > maxAmount) message = this.appService.translate('GROUP_VALIDATION.MAX_ITEMS_AMOUNT', { max: this.appService.parseCurrency(maxAmount) });
			if (message) {
				this.appService.alert({ content: message }).then(() => {
					reject({ type: "orderLimit" });
				})
			} else {
				resolve(null);
			}
		});
	}

	getUpsaleGroup(groupId) {
		let target = _.get(this.$storage.catalog, 'offerBundles', []);
		let upsaleGroup: any = _.find(target, { _id: groupId });
		if (!upsaleGroup) return;
		if (upsaleGroup._prepared) return upsaleGroup;
		this.orderUtils.prepareUpsaleGroup(upsaleGroup, this.$storage);
		return upsaleGroup;
	}

	getUpsaleGroups(activationMode) {
		let groups = _.filter(this.$storage.catalog.offerBundles, (group) => {
			if (!group.activation || group.activation.indexOf(activationMode) == -1) return false;
			if (!group._prepared) {
				this.orderUtils.prepareUpsaleGroup(group, this.$storage);
			}
			return group.active;
		});
		return groups;
	}

	// ------------------------------------------------------------------------------->
	// extra offers
	// ------------------------------------------------------------------------------->

	prepareExtraOffers(storage) {
		storage.extraOffersPrepared = true;
		const catalogTrans = storage.catalogTrans;

		//single extra offers ----------------------------->
		if (_.get(storage.catalog, 'extraOffers[0]')) {
			storage.extraOffersMethod = "single";
			let extraOffers = [];
			_.each(storage.catalog.extraOffers, (_offer) => {
				if (!_offer.active || storage.catalog.inventory[_.get(_offer.orderedItems, '[0].item')]) return;
				if (_.get(_offer.services, '[0]') && _offer.services.indexOf(storage.orderMode) == -1) return;
				if (!_offer.maxCount) _offer.maxCount = 5;

				if (_offer.menus) {
					if (!_offer.subGroups) _offer.subGroups = [];
					_offer.subGroups.unshift({
						menus: _offer.menus,
						menuMultiplier: _offer.menuMultiplier
					});
					delete _offer.menus;
					delete _offer.menuMultiplier;
				}

				_offer.count = 0;
				_offer.displayName = _offer.name;
				if (_offer.customName && _offer.customName.length) {
					_offer.displayName = _offer.customName;
				}

				if (storage.isTranslated) {
					_offer.displayName = _.get(_offer, `translations.${catalogTrans}.name`, _offer.displayName);
				}

				if (_offer.maxCount && _offer.maxCount > 1) {
					storage.extraOffersMethod = "multi";
				} else {
					_offer.maxCount == 1;
				}
				extraOffers.push(_offer);
			});
			if (extraOffers.length) {
				storage.extraOffers = extraOffers;
			}
		}

		//extra questions ------------------------------------>
		if (_.get(storage.catalog, 'extraQuestions[0]')) {
			_.remove(storage.catalog.extraQuestions, (question: any) => {
				if (_.get(question.services, '[0]') && question.services.indexOf(storage.orderMode) == -1) return true;
				let _offer = question.offer;
				if (_offer) {
					if (!_offer.active || storage.catalog.inventory[_.get(_offer.orderedItems, '[0].item')]) return true;
				}
				if (!question.enableSelection) {
					question.requiereSelection = false;
					question.active = true;
					question.disabled = true;
				}
				question.displayName = question.name;
				if (catalogTrans) {
					question.displayName = _.get(question, `translations.${catalogTrans}.name`, question.displayName);
				}
			});
			if (storage.catalog.extraQuestions.length) {
				storage.catalog.extraQuestions = storage.catalog.extraQuestions;
			}
		}

		//multi extra offers ------------------------------------>
		if (_.get(storage.catalog, 'extraOffersGroups[0]')) {
			let groups = [];
			_.each(storage.catalog.extraOffersGroups, (group, index) => {
				if (!_.get(group, 'offers[0]')) return;
				if (_.get(group.services, '[0]') && group.services.indexOf(storage.orderMode) == -1) return;
				_.remove(group.offers, (_offer: any) => {
					if (!_offer.active || storage.catalog.inventory[_.get(_offer.orderedItems, '[0].item')]) return true;
					_offer.count = 0;
					_offer.displayName = _offer.name;
					if (_offer.customName && _offer.customName.length) {
						_offer.displayName = _offer.customName;
					}
					if (storage.isTranslated) {
						//translate catalog
						_offer.displayName = _.get(_offer, `translations.${catalogTrans}.name`, _offer.displayName);
					}
				});
				if (group.offers.length) {
					group._id = `A${index}`;
					group.count = 0;
					if (!group.maxCount) group.maxCount = 5;
					if (catalogTrans) {
						group.name = _.get(group, `translations.${catalogTrans}.name`, group.name);
					}
					groups.push(group);
				}
			});
			if (groups.length) {
				storage.extraOffersGroups = groups;
			}
		}
	}

	getExtraOffers(storage) {
		if (!storage.extraOffersPrepared) this.prepareExtraOffers(storage);
		delete storage.extraOffersParsed;
		let that = this;

		let hasExtraQuestions = false;
		_.each(storage.catalog.extraQuestions, question => {
			question._visible = true;
			if (question.limitByMenu && _.get(question.menus, '[0]')) {
				question._visible = false;
				_.each(storage.basket, function (o) {
					let menus = findOfferMenuS(o.offer);
					if (_.intersection(question.menus, menus)[0]) {
						question._visible = true;
						hasExtraQuestions = true;
						return false;
					}
				});
				if (!question._visible) question.active = false;
			} else {
				hasExtraQuestions = true;
			}
		});

		let selectedExtraOffersGroups = storage.selectedExtraOffersGroups;
		let extraOffersGroups = [];
		let hasExtraOffersGroups: boolean = false;

		_.each(storage.extraOffersGroups, (group) => {
			let maxCount = group.maxCount;
			if (_.get(group, 'subGroups[0]')) {
				let max = 0;
				_.each(storage.basket, (o) => {
					let menus = findOfferMenuS(o.offer);
					_.each(group.subGroups, subGroup => {
						if (subGroup.menus && _.intersection(subGroup.menus, menus)[0]) {
							if (!subGroup.menuMultiplier) subGroup.menuMultiplier = 1;
							max += ((o.quantity || 1) * subGroup.menuMultiplier);
							return false;
						}
					});
				});
				maxCount = Math.min(max, group.maxCount);
			}
			if (maxCount > 0) {
				let newGroup = _.find(selectedExtraOffersGroups, { _id: group._id });
				if (!newGroup || newGroup.count > maxCount) {
					newGroup = _.cloneDeep(group);
				}
				extraOffersGroups.push(newGroup);
				newGroup.maxCount = maxCount;

				if (newGroup.requireSelection) {
					newGroup.$info = that.appService.translate('GROUP_VALIDATION.SELECT_BETWEEN', { min: 1, max: maxCount });
					newGroup.$minMessage = that.appService.translate('GROUP_VALIDATION.GROUP_SELECT_SINGLE_ERROR', { group: newGroup.name });
				} else {
					newGroup.$info = that.appService.translate('GROUP_VALIDATION.SELECT_UPTO_SOME_ALT', { max: maxCount });
				}
			}
		});
		if (extraOffersGroups.length) {
			hasExtraOffersGroups = true;
		} else {
			storage.selectedExtraOffersGroups = [];
		}


		let extraOffers = [];
		let extraOffersMethod = 'single';
		let selectedOffers = storage.selectedExtraOffers || [];
		let hasExtraOffers: boolean = false;

		_.each(storage.extraOffers, function (_offer) {
			if (!_offer.maxCount) _offer.maxCount = 5;
			var newOffer = _.cloneDeep(_offer);
			var chk: any = _.find(selectedOffers, { offer: _offer.offer });
			if (chk) newOffer.count = chk.count;

			if (_.get(newOffer, 'subGroups[0]')) {
				let max = 0;
				_.each(storage.basket, function (o) {
					let menus = findOfferMenuS(o.offer);
					_.each(newOffer.subGroups, group => {
						if (group.menus && _.intersection(group.menus, menus)[0]) {
							if (!group.menuMultiplier) group.menuMultiplier = 1;
							max += ((o.quantity || 1) * group.menuMultiplier);
							return false;
						}
					});
				});
				newOffer.maxCount = Math.min(max, _offer.maxCount);
				if (newOffer.count && newOffer.count > newOffer.maxCount) newOffer.count = newOffer.maxCount;
			}

			if (newOffer.maxCount == 0) return;
			if (newOffer.maxCount > 1) {
				extraOffersMethod = 'multi';
			}
			extraOffers.push(newOffer);
		});
		if (extraOffers.length) {
			hasExtraOffers = true;
		} else {
			storage.selectedExtraOffers = [];
		}

		if (!hasExtraOffers && !hasExtraOffersGroups && !hasExtraQuestions) {
			return null;
		}

		let hasBasketAlcohol = !storage.order.alcoholAtCashier && this.hasBasketAlcohol(storage)
		if (hasBasketAlcohol) {
			if (!storage.alcoholQuestion) {
				const alcoholAge = this.appService.regionArgs.alcoholVerificationAge;
				storage.alcoholQuestion = { name: this.appService.translate("TD.alcohol_decleration", { age: alcoholAge }), _visible: false, requiereSelection: true, $isAlcohol: true }
				storage.alcoholQuestion.displayName = storage.alcoholQuestion.name;
			}
		} else {
			delete storage.alcoholQuestion;
		}

		storage.extraOffersParsed =  {
			hasExtraOffers: hasExtraOffers,
			hasExtraQuestions: hasExtraQuestions,
			extraOffersMethod: extraOffersMethod,
			offers: extraOffers,
			hasExtraOffersGroups: hasExtraOffersGroups,
			groups: extraOffersGroups
		}
		return true;

		function findOfferMenuS(_offerId) {
			var ret;
			var arr = storage.catalog.view;
			for (var i = 0; i < arr.length; i++) {
				var ret = findRecursive(arr[i], _offerId, []);
				if (ret) {
					return ret;
				}
			}
			function findRecursive(o, _offerId, menus) {
				if (o.offer && o.offer == _offerId) return menus;
				if (o.items) {
					menus = [o._id].concat(menus);
					var _arr = o.items, el;
					for (var i = 0; i < _arr.length; i++) {
						el = _arr[i];
						if (_.get(el, 'crossSale.offers[0]') && el.crossSale.offers.find(o => o.offer == _offerId) != null) return menus;
						if (_.get(el, 'preSale.offers[0]') && el.preSale.offers.find(o => o.offer == _offerId) != null) return menus;
						var _ret = findRecursive(el, _offerId, menus);
						if (_ret) {
							return _ret;
						}
					}
				}
			}
		}
	}

	// ------------------------------------------------------------------------------->
	// alcohol
	// ------------------------------------------------------------------------------->

	checkBasketAlcohol(storage) {
		let hasBasketAlcohol = !storage.order.alcoholAtCashier && this.hasBasketAlcohol(storage)
		if (hasBasketAlcohol) {
			if (!storage.alcoholQuestion) {
				const alcoholAge = this.appService.regionArgs.alcoholVerificationAge;
				storage.alcoholQuestion = this.appService.translate("TD.alcohol_decleration", { age: alcoholAge });
			}
		} else {
			delete storage.alcoholQuestion;
		}
	}

	hasBasketAlcohol(storage) {
		let hasAlcohol = false;
		_.each(storage.basket, (offer) => {
			checkItem(offer._item);
			if (hasAlcohol) return false;
			_.each(offer.selectionSummary, (selectionGroup) => {
				_.each(selectionGroup.items, (item) => {
					checkItem(item._item);
					if (hasAlcohol) return false;
				});
			});
		});

		if (!hasAlcohol) {
			_.each(storage.order.extraOffers, (offer) => {
				let count = offer.count || 0;
				if (count) {
					_.each(offer.orderedItems, oi => {
						if (checkModItem(oi.item)) {
							hasAlcohol = true;
							return false;
						};
					})
				}
			});
		}

		return hasAlcohol;

		function checkItem(item) {
			if (!item) return;
			if (item.alcoholQuantity) {
				hasAlcohol = true;
				return false;
			}
			_.each(item.modifierGroups, (group) => {
				if (hasAlcohol) return false;
				if (group.singleSelection) {
					let mod = _.find(group.modifiers, { '_selected': true });
					if (mod) {
						if (checkModItem((mod.item && mod.item._id) || mod.item)) {
							hasAlcohol = true;
							return false;
						};
					}
				} else {
					_.each(group.modifiers, (mod) => {
						if (mod.formationUnit) {
							if (checkModItem((mod.item && mod.item._id) || mod.item)) {
								hasAlcohol = true;
								return false;
							};
						}
					});
				}
			});
		}

		function checkModItem(itemId) {
			if (!itemId) return;
			let item = _.find(storage.catalog.items, { "_id": itemId });
			if (item && item.alcoholQuantity) return true;
		}
	}

	// ------------------------------------------------------------------------------->
	// messages
	// ------------------------------------------------------------------------------->

	async popMessages(storage, placement, forceOnce?) {
		let messages = _.filter(storage.messages, { placement: placement, isNew: true });
		if (!messages.length) return Promise.resolve(null);
		return this.popMessage(storage, messages, 0, forceOnce)
	}
	async popMessage(storage, messages, index, forceOnce?) {
		if (!storage.messages) return Promise.reject();
		let that = this;
		let message = messages[index];
		if (!message) return Promise.resolve(null);
		if (message.showOnce || forceOnce) message.isNew = false;
		switch (message.displayType) {
			case "image":
				let url = _.get(message, 'desktopImage.url');//, 'assets/images/card_swipe.svg'
				if (!url) return Promise.resolve(null);
				return this.appService.imageDialog(url).then(() => {
					return that.popMessage(storage, messages, index + 1, forceOnce);
				});
			default:
				let text = _.get(message, `translations.${storage.catalogTrans}.message`, message.message);
				return this.appService.alert({ content: text }).then(() => {
					return that.popMessage(storage, messages, index + 1, forceOnce);
				});
		}
	}

	//---------------------------------------------------------------------------------------------->
	//
	//---------------------------------------------------------------------------------------------->

	getOrderError (error) {
		let $storage = this.$storage;
		let errorData = error?.data;
		let message;
		switch (errorData?.code) {
			case 404001:
				if ($storage.tableNumber) {
					message = this.appService.translate('MESSAGES.TABLE_X_NOT_FOUND', {v:$storage.tableNumber});
				}
				break;
			case 409040:
				message = this.formatInventoryOutOfStockError(errorData.outOfStock, $storage);
				break;
			case 409946:
				message = this.appService.translate('MESSAGES.OUT_OF_BALANCE');
				break;
			case 409002:
				message = this.appService.translate('MESSAGES.ONLINE_TABLE_ORDERING_DISABLED');
				break;
		}
		if (!message) message = this.appService.getErrorCodeTrans(errorData?.code);
		return message;
	}
	showOrderError(error, isVirtual?) {
		let message = this.getOrderError(error);
		if (!message) {
			message = this.appService.translate('MESSAGES.LOAD_RESOURCE_ERROR');
		}
		this.appService.alert({ content: message });
		//this.appService.alert({ content: this.appService.serializeError(err) });
	}

	formatInventoryOutOfStockError(outOfStockItems, _storage) {
		let minStock = 0;
		let items = outOfStockItems.map(o => {
			let name = (_storage.catalog.items.find(i => i._id === o.item) || {}).name;
			let qty = o.required - Math.max(o.stockCount - minStock, 0);
			return `[ ${qty} x ${name} ]`
		}).join('\n');
		return this.appService.translate('MESSAGES.OUT_OF_STOCK', { items: items });
	}

	//------------------------------------------------------------------------------------------------------------------->
	//------------------------------------------------------------------------------------------------------------------->
	//------------------------------------------------------------------------------------------------------------------->

	prepareUserHistory(from?) {
		this.orderHistory.prepareHistoryFolder(this.$storage, this.tempHistory);
		if (this.$storage.workMode == 'tabitOrder')this.cacheOrder();
	}

	//------------------------------------------------------------------------------------------------------------------->
	//------------------------------------------------------------------------------------------------------------------->
	//------------------------------------------------------------------------------------------------------------------->

	activityTimerSubject = new Subject<string>();
	noActivityTimer;
	timerActive;
	startActivityTimer(_interval?) {
		this.stopActivityTimer();
		let diff = moment().diff(this.$storage.orderStartDate, 'minutes');
		let interval = _interval ? _interval : (this.appService.appConfig.isDev ? 60 : 30) - diff;

		this.noActivityTimer = setTimeout(() => {
			if (this.generalUtils.canCreateEatinOrder(this.$storage.config)) {
				this.activityTimerSubject.next('timeout');
			} else {
				this.activityTimerSubject.next('expired');
			}
		}, interval * 60000);
	}

	stopActivityTimer() {
		this.timerActive = false;
		clearTimeout(this.noActivityTimer);
	}

	//------------------------------------------------------------------------------------------------------------------->
	//------------------------------------------------------------------------------------------------------------------->
	//------------------------------------------------------------------------------------------------------------------->

	startFullView() {
		try {
			if (this.appService.isScreenRecorderEnabled(this.$storage.config)) {
				this.appService.initFullViewScript().then(() => {
					this.$storage.isScreenRecorderEnabled = true;
					this.appService.initOrUpdateFullViewRecord(this.$storage);
				});
			}
		} catch (e) {
		}
	}

	//------------------------------------------------------------------------------------------------------------------->
	//------------------------------------------------------------------------------------------------------------------->
	//------------------------------------------------------------------------------------------------------------------->

	restoreOrder(workMode = 'tabitOrder') {
		if (this.$storage?._restored) {
			delete this.$storage?._restored;
			return this.$storage;
		}
		const cacheStorage = sessionStorage.getItem('orderCache');
		if (cacheStorage) {
			try {
				let _storage = JSON.parse(cacheStorage);
				if (_storage.siteId == this.appService.getOrganization() && _storage.workMode == workMode) {
					this.$storage = _storage;
					this.appService.allowForeignNumbers(this.$storage?.config?.allowForeignNumbers);
					return true;
				}

				if (this.$storage.hasMobileWallet) {
					this.expayService.initMobileWalletScripts();
				}

			} catch (e) { }
		}
	}

	cacheOrderTimer;
	cacheOrder() {
		if (this.$storage.workMode != 'tabitOrder') return;
		clearTimeout(this.cacheOrderTimer);
		this.cacheOrderTimer = setTimeout(() => {
			this.cacheOrderNow();
		}, 250);
	}
	cacheOrderNow() {
		let orderCacheString = JSON.stringify(this.$storage, (key, value) => {
			if (key == "tmpViewOffers") {
				return undefined;
			}
			return value;
		});
		sessionStorage.setItem('orderCache', orderCacheString);
	}

	clearOrder() {
		if (this.$storage.workMode != 'tabitOrder') return;
		this.initNewStorage();
		sessionStorage.removeItem('orderCache');
	}

	cacheBasket() {
		let basket = [];
		let basketCache = this.$storage.basketCache || [];
		this.$storage.basket.concat(basketCache).forEach((item) => {
			let match = basket.find(o => o.offer === item.offer);
			if (match && match._item?.summary?.text == item._item?.summary?.text) return;
			basket.push(item);
		});
		localStorage.setItem('basketCache', JSON.stringify({
			date: new Date(),
			siteId: this.appService.getOrganization(),
			basket:basket,
		}));
	}

	//------------------------------------------------------------------------------------------------------------------->
	//------------------------------------------------------------------------------------------------------------------->
	//------------------------------------------------------------------------------------------------------------------->




}
